import { render, staticRenderFns } from "./Validasi.vue?vue&type=template&id=37f41c08&"
import script from "./Validasi.vue?vue&type=script&lang=js&"
export * from "./Validasi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports